import { useDispatch, useSelector } from "react-redux";
import { changeMenuItem, getCodePopup, setCode } from "../redux/actions";
import { TopTable } from "../components/TopTable";
import React, { useEffect } from 'react';
import { SearchByUser } from "../components/SearchByUser";
import { Qaa } from "./Qaa";
import { Support } from "./Support";
import { MobilePopup } from "../components/popups/MobilePopup";
import { EmptyTable } from "../components/EmptyTable";
import { Games } from "./Games";
import { ConditionsSwitch } from "../components/СonditionsSwitch";
import { TopPanel } from "../components/TopPanel"
import { GroupPanel } from "../components/GroupPanel";
import { GameShopLogin } from "../components/gameShop/gameShopLogin/GameShopLogin";
import { Shop } from "./Shop";

export const UserPage = () => {
    const dispatch = useDispatch()
    const isMobile = useSelector(state => state.app.isMobile)
    const isActive = useSelector(state => state.user.isActive)
    const isSupportEnabled = useSelector(state => state.user.isSupportEnabled)
    const showLink = useSelector(state => state.user.showLink)
    const isPartnerEnabled = useSelector(state => state.user.isPartnerEnabled)
    const link = useSelector(state => state.user.link)
    const hasActiveGame = useSelector(state => state.user.hasActiveGame)
    const wheelStatus = useSelector(state => state.game.gameWheel?.settings?.status)
    const shopStatus = useSelector(state => state.game.gameShop?.settings?.status)
    const menuItem = useSelector(state => state.app.menuItem)
    const menuSubitem = useSelector(state => state.app.menuSubitem)
    const lang = useSelector(state => state.app.currentLang)
    const alert = useSelector(state => state.app.alert)
    const tableList = useSelector(state => state.table.list)
    const isGroup = useSelector(state => state.app.group)
    const isSameTab = useSelector(state => state.game.gameShop?.settings?.isSameTab)
    const isLogin = useSelector(state => state.user.isLogin)
    useEffect(() => {
        let params = (new URL(document.location)).searchParams;
        let code = params.get("code");
        if (hasActiveGame && typeof code === 'string' && code.length > 0) {
            dispatch(getCodePopup());
            dispatch(setCode(code));
        }
    }, [dispatch, hasActiveGame])

    /*Для мобильных*/
    if (isMobile) {
        return (
            <div className="mainContainer">
                <div className="mainContent">

                    <TopPanel />
                    <MobilePopup />

                    {
                        menuItem === 'conditionals' && isActive === 1 && (
                            <React.Fragment>
                                {/* {
                                    hasActiveGame && isSameTab === 1 && typeof wheelStatus === 'string' && wheelStatus !== 'archived' && typeof shopStatus === 'string' && shopStatus !== 'archived' && menuSubitem === 'games' && (<GameShopLogin />)
                                }
                                <ConditionsSwitch />
                                {
                                    hasActiveGame && (isSameTab === 0 || (isSameTab === 1 && (wheelStatus === 'archived' ||  typeof wheelStatus !== 'string') )) && typeof shopStatus === 'string' && shopStatus !== 'archived' && (menuSubitem === 'shop' || (menuSubitem === 'games' && isLogin)) && (<GameShopLogin />)
                                } */}
                                <ConditionsSwitch />
                                {
                                    hasActiveGame && typeof shopStatus === 'string' && shopStatus !== 'archived' && (menuSubitem === 'shop' || (menuSubitem === 'games' && (isLogin  || isSameTab === 1))) && (<GameShopLogin />)
                                }
                                {
                                    hasActiveGame && typeof wheelStatus === 'string' && wheelStatus !== 'archived' && menuSubitem === 'games' && (<Games />)
                                }{
                                    hasActiveGame && (isSameTab === 0 || (isSameTab === 1 && (wheelStatus === 'archived' ||  typeof wheelStatus !== 'string') )) && typeof shopStatus === 'string' && shopStatus !== 'archived' && menuSubitem === 'shop' && (<Shop />)
                                }
                                <div className="userTable">
                                    <SearchByUser />
                                    <TopTable />
                                </div>
                            </React.Fragment>
                        )
                    }

                    {
                        menuItem === 'conditionals' && isActive !== 1 && (<EmptyTable />)
                    }
                    {
                        menuItem === 'conditionals' && isActive === 1 &&
                        (!Array.isArray(tableList) || (tableList.length === 0)) && (<EmptyTable isActive={isActive} />)
                    }
                </div>
                <div className={'error-alert ' + (alert.isShow === true ? 'show ' : '') + (alert.isShow === false ? 'hide ' : '')}>{alert.text}</div>
            </div>
        )
    }
    /*Для десктоп*/
    return (
        <div className="mainContainer">
            <div className="mainSidebar">

                <TopPanel />
                <div className="userMenu">
                    <div className={'userMenu__link conditionals ' + (menuItem === 'conditionals' ? 'active' : '')}
                        onClick={() => dispatch(changeMenuItem('conditionals'))}>
                        <span>{lang.menu1}</span>
                    </div>
                    {
                        isSupportEnabled === 1 && (isPartnerEnabled === null || isPartnerEnabled === 1) && (
                            <div className={'userMenu__link support ' + (menuItem === 'support' ? 'active' : '')}
                                onClick={() => dispatch(changeMenuItem('support'))}>
                                <span>{lang.menu2}</span>
                            </div>
                        )
                    }
                    {
                        lang.qaa.length > 0 && (
                            <div className={'userMenu__link qaa ' + (menuItem === 'qaa' ? 'active' : '')}
                                onClick={() => dispatch(changeMenuItem('qaa'))}>
                                <span>{lang.menu3}</span>
                            </div>
                        )
                    }
                    {
                        showLink != null && link != null && (
                            <a href={process.env.REACT_APP_HOST + link} target="_blank" rel="noreferrer"
                                className="userPartnerLink">
                                <span>{lang.menu4}</span>
                            </a>
                        )
                    }
                </div>
            </div>
            <div className="mainContent whiteBox">
                {
                    isGroup && <GroupPanel />
                }
                {
                    menuItem === 'conditionals' && isActive === 1 && (
                        <React.Fragment>
                            <ConditionsSwitch />
                            {
                                hasActiveGame && typeof shopStatus === 'string' && shopStatus !== 'archived' && (menuSubitem === 'shop' || (menuSubitem === 'games' && (isLogin || isSameTab === 1))) && (<GameShopLogin />)
                            }
                            {
                                hasActiveGame && typeof wheelStatus === 'string' && wheelStatus !== 'archived' && menuSubitem === 'games' && (<Games />)
                            }{
                                hasActiveGame && typeof shopStatus === 'string' && shopStatus !== 'archived' && (isSameTab === 0 || (isSameTab === 1 && (wheelStatus === 'archived' ||  typeof wheelStatus !== 'string') )) && menuSubitem === 'shop' && (<Shop />)
                            }
                            <SearchByUser />
                            <TopTable />
                        </React.Fragment>
                    )
                }

                {
                    (menuItem === 'conditionals' && isActive !== 1) && (<EmptyTable />)
                }
                {
                    menuItem === 'conditionals' && isActive === 1 &&
                    (!Array.isArray(tableList) || (tableList.length === 0)) && (<EmptyTable isActive={isActive} />)
                }
                {
                    menuItem === 'support' && isSupportEnabled && (<Support />)
                }
                {
                    menuItem === 'qaa' && lang.qaa.length > 0 && (<Qaa />)
                }
            </div>
            <div className={'error-alert ' + (alert.isShow === true ? 'show ' : '') + (alert.isShow === false ? 'hide ' : '')}>{alert.text}</div>
        </div>
    )
}